// Mirrors IFSPD-mentor-api/config/year2.php — squad_criteria_by_council (Wave 4A).

export const YEAR2_SQUAD_CRITERIA_BY_COUNCIL = {
  1: {
    council_number: 1,
    title: 'The Diagnosis',
    tagline: 'What is actually happening, and why does it stay that way?',
    strengths: [
      'High Readiness', 'High Task Focus', 'High Team Participation', 'Well Organised',
      'Strong Inter-Team Collaboration', 'High Team Unity', 'High Time Management',
      'High Thinking Depth', 'High Evidence Grounding', 'Strong Challenge Response',
    ],
    coaching: [
      'Low Readiness', 'Low Task Focus', 'Low Team Participation', 'Poorly Organised',
      'Weak Inter-Team Collaboration', 'Low Team Unity', 'Low Time Management',
      'Low Thinking Depth', 'Low Evidence Grounding', 'Weak Challenge Response',
    ],
  },
  2: {
    council_number: 2,
    title: 'The Insight',
    tagline: 'Where exactly should we push — and why will pushing there work?',
    strengths: [
      'High Readiness', 'High Task Focus', 'High Team Participation', 'Well Organised',
      'Strong Inter-Team Collaboration', 'High Team Unity', 'High Time Management',
      'High Persuasive Strength', 'Strong Interview Evidence', 'Sharp Prioritisation',
    ],
    coaching: [
      'Low Readiness', 'Low Task Focus', 'Low Team Participation', 'Poorly Organised',
      'Weak Inter-Team Collaboration', 'Low Team Unity', 'Low Time Management',
      'Low Persuasive Strength', 'Weak Interview Evidence', 'Vague Prioritisation',
    ],
  },
  3: {
    council_number: 3,
    title: 'The Startup',
    tagline: 'Can we prove our idea works — in one day, close to home?',
    strengths: [
      'High Readiness', 'High Task Focus', 'High Team Participation', 'Well Organised',
      'Strong Inter-Team Collaboration', 'High Team Unity', 'High Time Management',
      'Well-Scoped Proposal', 'Strong SDG Alignment', 'Strong Challenge Response',
    ],
    coaching: [
      'Low Readiness', 'Low Task Focus', 'Low Team Participation', 'Poorly Organised',
      'Weak Inter-Team Collaboration', 'Low Team Unity', 'Low Time Management',
      'Poorly-Scoped Proposal', 'Weak SDG Alignment', 'Weak Challenge Response',
    ],
  },
  4: {
    council_number: 4,
    title: 'The Proposal',
    tagline: 'If this worked here, how do we make it work everywhere?',
    strengths: [
      'High Readiness', 'High Task Focus', 'High Team Participation', 'Well Organised',
      'Strong Inter-Team Collaboration', 'High Team Unity', 'High Time Management',
      'Strong Synthesis', 'Sharp Recommendation', 'Honest Reporting',
    ],
    coaching: [
      'Low Readiness', 'Low Task Focus', 'Low Team Participation', 'Poorly Organised',
      'Weak Inter-Team Collaboration', 'Low Team Unity', 'Low Time Management',
      'Weak Synthesis', 'Vague Recommendation', 'Overstated Reporting',
    ],
  },
  5: {
    council_number: 5,
    title: 'The Crucible',
    tagline: 'Can your policy survive real questions from a real room?',
    strengths: [
      'High Readiness', 'High Task Focus', 'High Team Participation', 'Well Organised',
      'Strong Inter-Team Collaboration', 'High Team Unity', 'High Time Management',
      'Strong Stage Presence', 'Strong Defence', 'High Adaptive Reasoning',
    ],
    coaching: [
      'Low Readiness', 'Low Task Focus', 'Low Team Participation', 'Poorly Organised',
      'Weak Inter-Team Collaboration', 'Low Team Unity', 'Low Time Management',
      'Weak Stage Presence', 'Weak Defence', 'Low Adaptive Reasoning',
    ],
  },
};
